// Common country dial codes for the reseller form. Admin can also type any value.
export const COUNTRIES = [
  { name: "Bangladesh", code: "880" },
  { name: "India", code: "91" },
  { name: "Pakistan", code: "92" },
  { name: "United Arab Emirates", code: "971" },
  { name: "Saudi Arabia", code: "966" },
  { name: "Egypt", code: "20" },
  { name: "Brazil", code: "55" },
  { name: "Indonesia", code: "62" },
  { name: "Malaysia", code: "60" },
  { name: "Turkey", code: "90" },
  { name: "United States", code: "1" },
  { name: "United Kingdom", code: "44" },
  { name: "Nigeria", code: "234" },
  { name: "Philippines", code: "63" },
  { name: "Iraq", code: "964" },
  { name: "Morocco", code: "212" },
];
